<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Object | null,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isSelected() {
      return this.selected && this.selected.fecha === this.item.fecha;
    },
  },
  methods: {
    formatDate(fecha){
      const partes = fecha.slice(0, 10).split("-");
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }
  }
};
</script>

<template>
  <tr @click="!disabled ? $emit('update', item) : false" :class="{ selected: isSelected, disabled }">
    <td>{{ formatDate(item.fecha) }}</td>
    <td>{{ item.codigoDiaSemana }}</td>
    <td>{{ item.nombreCiudadEs }}</td>
  </tr>
</template>

<style>
.incorporacionAbandono tr:not(.disabled):hover {
  cursor: pointer;
}
.incorporacionAbandono tr.selected,
.incorporacionAbandono tr:hover {
  background-color: var(--gris-medio);
}
.incorporacionAbandono tr.disabled {
  color: var(--gris-medio);
  background-color: var(--gris-claro);
}
</style>
